<script setup lang="ts">
import { ref } from 'vue';

import { useElementEmptiness } from '#composables/useElementEmptiness';
import { useLanguage } from '#composables/useLanguage';

defineProps<{
  title?: string;
}>();

const { t } = useLanguage();

const elementRef = ref<HTMLElement | null>(null);
const hideMetricRow = useElementEmptiness(elementRef);
</script>

<template>
  <div v-if="!hideMetricRow" class="w-full flex flex-col">
    <h3 v-if="title" class="font-bold text-2xl mb-6" v-text="t(title)" />
    <div ref="elementRef" class="flex flex-row place-items-stretch gap-4 flex-1">
      <slot />
    </div>
  </div>
</template>
